var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "video",
      {
        staticClass: "video-message",
        attrs: { controls: "", autoplay: _vm.autoplay, muted: "" },
        domProps: { muted: true },
      },
      [
        _c("source", { attrs: { src: _vm.url } }),
        _vm._v("\n    Your browser does not support video.\n  "),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }